// src/config.js
const backendURL = process.env.REACT_APP_BACKEND_URL;
const googleAPIKEY = process.env.REACT_APP_GOOGLE_API_KEY;
const googleClientID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const versionNumber = 'v0.1.0'

// Export the variables
export { backendURL, googleClientID, googleAPIKEY, versionNumber };